<template>
  <div class="layout-header">
    <div class="header-menu-pane">
      <div class="header-menu-left">
        <el-menu class="header-menu-left" mode="horizontal" @select="handleMenuItemSelect">
          <el-menu-item index="toggle-collapse-side-nav-menu" class="hidden-xs-only">
            <i class="iconfont" :class="navMenuObj.isCollapsed ? 'icon-menu-unfold1' : 'icon-menu-fold1'"></i>
          </el-menu-item>
          <el-menu-item index="toggle-collapse-m-nav-menu" class="hidden-sm-and-up">
            <i class="iconfont" :class="navMenuObj.isShow ? 'icon-menu-fold1' : 'icon-menu-unfold1'"></i>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="header-menu-right">
        <div class="extra-menu">
          <div class="extra-menu-item-wrap">
            <div class="extra-menu-item" :class="{'is-selected': showMessageCenter}" @click.stop="toggleMessageCenter">
              <el-badge :value="messageState.unreadCount" :max="99" :hidden="messageState.unreadCount <= 0">
                <i class="iconfont icon-xiaoxi" :class="{'message-notice': messageState.unreadCount > 0}"></i>
              </el-badge>
            </div>
            <transition name="animation-fade-slide-down">
              <div class="message-center-container" v-show="showMessageCenter" @click.stop>
                <LayoutMessageCenter :visible.sync="showMessageCenter"></LayoutMessageCenter>
              </div>
            </transition>
          </div>
        </div>
        <el-menu mode="horizontal" @select="handleMenuItemSelect">
          <el-tooltip :content="isFullScreen ? '退出全屏' : '全屏模式'" placement="bottom" :enterable="false">
            <el-menu-item index="toggle-full-screen" class="hidden-xs-only">
              <i class="iconfont" :class="isFullScreen ? 'icon-cancel-full-screen' : 'icon-full-screen'"></i>
            </el-menu-item>
          </el-tooltip>
          <template v-if="accountObj.bindInfo && accountObj.bindInfo.customize">
            <el-menu-item index="toggle-bind-users"
                          @click.native.stop>
              <LayoutBindUsers ref="bindUsers">
                <i class="iconfont icon-bangding"></i>
              </LayoutBindUsers>
            </el-menu-item>
          </template>
          <el-submenu index="personal-menu">
            <template slot="title">
              <i class="iconfont icon-account-only"></i>
              <span>{{accountObj.trueName}}</span>
            </template>
            <el-menu-item index="personal-info">
              <i class="iconfont icon-account-isolate"></i>
              <span>个人信息</span>
            </el-menu-item>
            <el-menu-item index="modify-password">
              <i class="iconfont icon-approve"></i>
              <span>修改密码</span>
            </el-menu-item>
            <el-menu-item index="setting-info">
              <i class="iconfont icon-config-safe"></i>
              <span>配置信息</span>
            </el-menu-item>
            <el-menu-item index="modify-theme">
              <i class="iconfont icon-business-server"></i>
              <span>更改主题</span>
            </el-menu-item>
            <el-menu-item index="logout">
              <i class="iconfont icon-carry-out"></i>
              <span>注销退出</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
        <el-dialog
          title="主题设置"
          width="600px"
          custom-class="theme-dialog"
          :append-to-body="true"
          :visible.sync="showThemeDialog">
          <div class="theme-dialog-cont"
               v-loading="isSettingTheme"
               element-loading-text="提交设置中，请稍等...">
            <div class="theme-option">
              <div class="theme-style">
                <el-radio-group v-model="themeObj.style"
                                @change="() => handleThemeChange()">
                  <el-radio label="">默认风格</el-radio>
                  <el-radio label="brief">简约风格</el-radio>
                </el-radio-group>
              </div>
            </div>
            <AppScrollbar style="height: 320px">
              <div class="theme-dialog-body">
                <el-row :gutter="16">
                  <el-col :xs="8" :sm="6" v-for="(option, index) in themeObj.options" :key="'theme-' + index">
                    <el-card shadow="never">
                      <div class="theme-item" :class="{'active': option.name === themeObj.current}" @click="handleThemeSelect(option)">
                        <div class="theme-wrap">
                          <div class="theme-content" :style="{'background': option.mainBackgroundColor}">
                            <div class="theme-header" :style="{'background': option.headerBackgroundColor}"></div>
                            <div class="theme-side" :style="{'background': option.primaryColor}">
                              <div class="theme-logo" :style="{'background': option.logoBackgroundColor}"></div>
                            </div>
                          </div>
                        </div>
                        <div class="theme-label">
                          <span>{{option.label}}</span>
                        </div>
                      </div>
                    </el-card>
                  </el-col>
                </el-row>
              </div>
            </AppScrollbar>
          </div>
        </el-dialog>
      </div>
    </div>
    <LayoutHeaderTabs class="header-tabs-pane"
                      v-on="$listeners"></LayoutHeaderTabs>
  </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import LayoutMessageCenter from './LayoutMessageCenter'
import LayoutBindUsers from './LayoutBindUsers'
import AppScrollbar from './elements/AppScrollbar'
import PasswordField from './elements/PasswordField'
import LayoutHeaderTabs from './LayoutHeaderTabs'
import layoutConstants from '../constants/layoutConstants'
export default {
  name: 'LayoutHeader',
  components: {
    LayoutMessageCenter,
    LayoutBindUsers,
    AppScrollbar,
    PasswordField,
    LayoutHeaderTabs
  },
  data () {
    return {
      showMessageCenter: false,
      showThemeDialog: false,
      isSettingTheme: false
    }
  },
  computed: mapState({
    navMenuObj: state => state.layout.side.navMenu,
    isFullScreen: state => state.layout.fullScreen,
    accountObj: state => state.account,
    themeObj: state => state.theme,
    messageState: state => state.message
  }),
  methods: {
    ...mapMutations(['toggleCollapseSideNavMenu']),
    ...mapMutations(['toggleShowSideNavMenu']),
    ...mapMutations(['toggleFullScreen']),
    ...mapMutations(['chooseTheme']),
    ...mapActions(['addMainTabAction']),
    isFullScreenEnable: function (state) {
      return document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled
    },
    toggleMessageCenter () {
      this.showMessageCenter = !this.showMessageCenter
    },
    hideMessageCenter () {
      this.showMessageCenter = false
    },
    handleMenuItemSelect (key, keyPath) {
      switch (key) {
        case 'toggle-collapse-side-nav-menu': {
          this.toggleCollapseSideNavMenu()
          break
        }
        case 'toggle-collapse-m-nav-menu': {
          this.toggleShowSideNavMenu()
          break
        }
        case 'toggle-full-screen': {
          if (this.isFullScreenEnable()) {
            this.toggleFullScreen()
          } else {
            this.$message({
              message: '浏览器不支持全屏模式',
              type: 'warning',
              center: true
            })
          }
          break
        }
        case 'toggle-bind-users': {
          let bindUsers = this.$refs.bindUsers
          if (bindUsers) {
            bindUsers.toggleVisible()
          }
          break
        }
        case 'personal-info': {
          this.addMainTabAction({
            name: '/tree/user',
            label: '个人中心',
            icon: 'iconfont icon-account-only',
            path: '/tree/user'
          }).then(success => {
            this.$nextTick(() => {
              if (success) {
                this.$router.replace('/tree/user/userPersonInfo')
              } else {
                this.$router.push('/tree/user/userPersonInfo')
              }
            })
          })
          break
        }
        case 'modify-password': {
          this.addMainTabAction({
            name: '/tree/user',
            label: '个人中心',
            icon: 'iconfont icon-account-only',
            path: '/tree/user'
          }).then(success => {
            this.$nextTick(() => {
              if (success) {
                this.$router.replace('/tree/user/userModifyPassword')
              } else {
                this.$router.push('/tree/user/userModifyPassword')
              }
            })
          })
          break
        }
        case 'setting-info': {
          this.addMainTabAction({
            name: '/tree/user',
            label: '个人中心',
            icon: 'iconfont icon-account-only',
            path: '/tree/user'
          }).then(success => {
            this.$nextTick(() => {
              if (success) {
                this.$router.replace('/tree/user/userSettingInfo')
              } else {
                this.$router.push('/tree/user/userSettingInfo')
              }
            })
          })
          break
        }
        case 'modify-theme': {
          this.showThemeDialog = true
          break
        }
        case 'logout': {
          // 标记登出状态5分钟后失效
          this.$cookies.set('logout', '1', 5 * 60, '/')
          window.location.href = this.$contextPath('/logout')
          break
        }
      }
    },
    handleThemeSelect (theme) {
      this.handleThemeChange({
        theme: theme.name,
        style: this.themeObj.style
      }, () => {
        this.chooseTheme(theme)
        this.showThemeDialog = false
      })
    },
    handleThemeChange (params, resolve) {
      // 设置用户主题
      this.isSettingTheme = true
      this.$ajax({
        url: '/workspace/manager/center/setTheme',
        method: 'post',
        data: this.$qs.stringify({
          themeStyle: JSON.stringify(params || {
            theme: this.themeObj.current,
            style: this.themeObj.style
          })
        })
      }).then((response) => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              resolve && resolve()
              break
            }
            default: {
              this.$message({
                message: response.data['message'],
                type: 'warning',
                center: true
              })
              break
            }
          }
        }
      }, () => {
        this.$message.error({
          message: '请求发送失败，请稍后重试',
          center: true
        })
      }).finally(() => {
        this.isSettingTheme = false
      })
    },
    installEvent () {
      this.$bus.$on(layoutConstants.event.LAYOUT_CLICK, this.hideMessageCenter)
    },
    releaseEvent () {
      this.$bus.$off(layoutConstants.event.LAYOUT_CLICK, this.hideMessageCenter)
    }
  },
  mounted () {
    this.installEvent()
  },
  beforeDestroy () {
    this.releaseEvent()
  }
}
</script>

<style lang="scss">
  @use "../styles/color" as *;

  .layout-header {
    position: relative;
    height: 100%;
    & > .header-menu-pane {
      height: 32px;
      .el-menu--horizontal{
        float: left;
        border-bottom: none!important;
        & > .el-menu-item {
          height: 32px;
          line-height: 30px;
          &:hover {
            background-color: #f9f9f9!important;
          }
        }
        & > .el-submenu {
          &.is-active {
            .el-submenu__title {
              border-bottom-color: transparent;
            }
          }
          .el-submenu__title {
            font-size: 12px;
            padding: 0 16px;
            height: 32px;
            line-height: 30px;
            color: #303133!important;
            &:hover {
              background-color: #f9f9f9!important;
            }
            i {
              color: #303133;
            }
            .el-submenu__icon-arrow {
              color: #303133;
              font-size: 13px;
              vertical-align: baseline!important;
            }
          }
        }
        .el-menu-item {
          color: #303133;
          i {
            color: #303133;
          }
          &.is-active {
            border-bottom-color: transparent;
          }
        }
      }
      .extra-menu {
        .extra-menu-item-wrap {
          position: relative;
          .message-center-container {
            position: absolute;
            right: 0;
            top: 100%;
            min-width: 300px;
            height: 400px;
            max-height: 460px;
            margin-top: 5px;
            border-radius: 4px;
            box-shadow: 0 2px 8px rgba(0,0,0,.2);
            z-index: 99;
            overflow: hidden;
          }
        }
        .extra-menu-item {
          color: #303133;
          height: 32px;
          line-height: 30px;
          cursor: pointer;
          &:hover,
          &.is-selected {
            background-color: #f9f9f9!important;
          }
          i {
            color: #303133;
          }
          .el-badge {
            vertical-align: -2px;
            .el-badge__content {
              border: none;
              &.is-fixed {
                left: 50%;
                top: 50%;
                right: auto;
                height: 17px;
                line-height: 17px;
                z-index: 2;
                transform: translate(-4%, -80%) scale(.8);
              }
            }
          }
          .message-notice {
            height: 24px;
            line-height: 24px;
            animation: bell-shake 2s linear 0s infinite;
            transform-origin: top center;
          }
        }
      }
      .header-menu-left {
        float: left;
        .el-menu--horizontal {
          & > .el-menu-item {
            padding-left: 6px;
            padding-right: 6px;
            &:after {
              content: '';
              position: absolute;
              right: 0;
              top: 50%;
              width: 1px;
              height: 10px;
              margin-top: -4px;
              background-color: #DCDFE6;
            }
          }
        }
        i {
          font-size: 16px;
        }
      }
      .header-menu-right {
        float: right;
        .extra-menu {
          float: left;
          .extra-menu-item {
            padding-left: 6px;
            padding-right: 6px;
          }
        }
        .el-menu--horizontal {
          & > .el-menu-item {
            padding-left: 16px;
            padding-right: 16px;
            &:after {
              content: '';
              position: absolute;
              right: 0;
              top: 50%;
              width: 1px;
              height: 10px;
              margin-top: -4px;
              background-color: #DCDFE6;
            }
          }
        }
        i {
          font-size: 16px;
        }
      }
      @keyframes bell-shake {
        0%{transform:rotate(0deg)}
        5%{transform:rotate(18deg)}
        15%{transform:rotate(-15deg)}
        25%{transform:rotate(12deg)}
        35%{transform:rotate(-9deg)}
        45%{transform:rotate(6deg)}
        55%{transform:rotate(-3deg)}
        60%{transform:rotate(0deg)}
        100%{transform:rotate(0deg)}
      }
    }
    & > .header-tabs-pane {
      position: relative;
      height: 32px;
      padding-top: 2px;
      box-sizing: border-box;
    }
  }

  .el-dialog__wrapper {
    & > .el-dialog {
      &.theme-dialog {
        & > .el-dialog__body {
          .theme-option {
            background-color: #fff;
            padding: 10px 15px;
            & > .theme-style {
              .el-radio-group {
                .el-radio {
                  margin-right: 15px;
                  & > .el-radio__label {
                    font-size: 13px;
                  }
                }
              }
            }
            & > .theme-mode {
              .el-switch {
                transform: translateX(6%) scale(.88);
              }
            }
          }
          .theme-dialog-body {
            padding: 15px 15px 0;
            .el-card {
              font-size: 12px;
              border-color: transparent;
              border-radius: 0;
              background-color: transparent;
              margin-bottom: 10px;
              overflow: visible;
              & > .el-card__header {
                padding: 6px 8px;
                text-align: center;
              }
              & > .el-card__body {
                padding: 0;
                .theme-item {
                  cursor: pointer;
                  &.active,
                  &:hover {
                    & > .theme-label {
                      color: #303133;
                    }
                    & > .theme-wrap {
                      &:after {
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        border-color: rgba(0,0,0,.2);
                        opacity: 1;
                      }
                    }
                  }
                  & > .theme-wrap {
                    position: relative;
                    padding: 5px;
                    &:after {
                      content: '';
                      position: absolute;
                      z-index: 2;
                      top: 50%;
                      left: 50%;
                      width: 1px;
                      height: 0;
                      border: 1px solid #f2f2f2;
                      transition: all .3s;
                    }
                    & > .theme-content {
                      position: relative;
                      height: 80px;
                      @media screen and (max-width:767px) {
                        height: 64px;
                      }
                      & > .theme-header {
                        height: 20%;
                      }
                      & > .theme-side {
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 20%;
                        bottom: 0;
                        box-shadow: 1px 0 2px 0 rgba(0,0,0,.05);
                        & > .theme-logo {
                          position: absolute;
                          left: 0;
                          top: 0;
                          right: 0;
                          height: 20%;
                          box-shadow: 0 1px 2px 0 rgba(0,0,0,.15);
                        }
                      }
                    }
                  }
                  & > .theme-label {
                    color: #666;
                    text-align: center;
                    line-height: 24px;
                    margin-top: 4px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
